import { render } from "./Tiyanjin.vue?vue&type=template&id=54e6b737&scoped=true"
import script from "./Tiyanjin.vue?vue&type=script&lang=js"
export * from "./Tiyanjin.vue?vue&type=script&lang=js"

import "./Tiyanjin.vue?vue&type=style&index=0&id=54e6b737&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e6b737"]])

export default __exports__